import React, { useState, useEffect } from "react";
import "../assets/css/RiskPredictor.css";
import { IoMdCloudUpload } from "react-icons/io";
import { spinnerOverlayStyle, spinnerStyle } from "./MapNavigator";
// import { MdFullscreen } from "react-icons/md";
import {
  predictSingleAPI,
  predictBatchAPI,
  fetchParameters,
} from "../services/apiServices";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// Required columns for batch CSV
const REQUIRED_COLS = [
  "elevation",
  "temperature_C",
  "humidity",
  "rainfall",
  "population_count",
  "water_bodies_distance",
];

export default function RiskPredictor() {
  const [tab, setTab] = useState("single");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loadingBatch, setLoadingBatch] = useState(false);
  const [predicting, setPredicting] = useState(false);
  const [inputs, setInputs] = useState();
  const [loadingParameters, setLoadingParameters] = useState(true);
  //dropdown states
  const [selectedRegionalState, setSelectedRegionalState] = useState("");
  const [selectedZone, setSelectedZone] = useState("");
  const [selectedWoreda, setSelectedWoreda] = useState("");
  const [selectedKebele, setSelectedKebele] = useState("");
  const [regionalStates, setRegionalStates] = useState([]);
  const [zones, setZones] = useState([]);
  const [woredas, setWoredas] = useState([]);
  const [kebeles, setKebeles] = useState([]);
  // Inline message shown beside "Enter Parameters Manually"
  const [inlineMsg, setInlineMsg] = useState({ text: "", type: "info" });
  
  // const [snackbar, setSnackbar] = useState({ message: "", visible: false });
  // function showSnackbar(message, duration = 3000) {
  //   setSnackbar({ message, visible: true });
  //   setTimeout(() => setSnackbar({ message: "", visible: false }), duration);
  // }
  const [singlePrediction, setSinglePrediction] = useState(null);
  const [predictionClass, setPredictionClass] = useState(null);
  // Batch state
  const [batchFileName, setBatchFileName] = useState(null);
  const [batchTable, setBatchTable] = useState(null);
  const [batchErrors, setBatchErrors] = useState(null);
  const [waterBodies, setWaterBodies] = useState([]);

  // Helper function to capitalize first letter of each word
  const capitalizeWords = (str) => {
    if (!str) return "";
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };
  const riskColors = {
    Low: "#4ade80",
    Moderate: "#f6c26b",
    High: "#b91c1c",
  }; const mapRiskRangeToClass = (range) => {
      if (!range) return "Unknown";
      if (range === "0-10%") return "Low";
      if (["10-20%", "20-30%", "30-40%", "40-50%"].includes(range))
        return "Moderate";
      return "High";
    };

  function downloadSampleCSV() {
    const sample = `woreda,zone,regionalState,elevation,temperature_C,humidity,rainfall,population_count,water_bodies_distance,water_body_name
Adaa'r,Awsi Rasu Zone,Afar,1465,24.18,40,0,0,21882.7851,water_body_name
Afambo,Awsi Rasu Zone,Afar,1221,25.38,41,0,32064,1178.448812,water_body_name
Asayita,Awsi Rasu Zone,Afar,740,27.15,39,0,84161,0,
Chifra,Awsi Rasu Zone,Afar,677,28.48,31,0,127884,2811.006902,water_body_name
Dubti,Awsi Rasu Zone,Afar,262,29.74,38,0,122641,1908.109242,Oued Degbour
Elidar,Awsi Rasu Zone,Afar,780,26.38,38,0,113755,2712.113709,water_body_name
Kori,Awsi Rasu Zone,Afar,1122,26.76,35,0,39470,3312.176326,water_body_name
Mille,Awsi Rasu Zone,Afar,662,28.1,34,0,0,0,
Abala,Kilbet Rasu Zone,Afar,733,26.3,39,0,60898,0,
Afdera,Kilbet Rasu Zone,Afar,568,27.08,40,0,45683,0,`;

    // Add BOM to fix Excel UTF-8 issue
    const blob = new Blob(["\uFEFF" + sample], {
      type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "parameter_example.csv";
    a.click();
    URL.revokeObjectURL(url);
  }
  useEffect(() => {
    async function loadOptions() {
      if (!selectedRegionalState) {
        const data = await fetchParameters("regional-state");
        const states = data.map((s) => s.regionalState);
        setRegionalStates(states);
        if (states.length) setSelectedRegionalState(states[0]);
        return;
      }

      if (selectedRegionalState && !selectedZone) {
        const data = await fetchParameters("zone");
        const filtered = data.filter(
          (d) => d.regionalState === selectedRegionalState
        );
        setZones(filtered.map((z) => z.zone));
        return;
      }

      if (selectedZone && !selectedWoreda) {
        const data = await fetchParameters("woreda");
        const filtered = data.filter((d) => d.zone === selectedZone);
        setWoredas(filtered.map((w) => w.woreda));
        return;
      }
      if (selectedWoreda) {
        const data = await fetchParameters("kebele");
        const filtered = data.filter((d) => d.woreda === selectedWoreda);
        setKebeles(filtered.map((k) => k.kebele));
        return;
      }
    }

    loadOptions();
  }, [selectedRegionalState, selectedZone, selectedWoreda]);
  useEffect(() => {
    async function loadParameters() {
      try {
        let data;
        let match;
        let label = "";
        setLoadingParameters(true);
        // Priority: kebele > woreda > zone > regionalState
        if (selectedKebele) {
          data = await fetchParameters("kebele");
          match = data.find((r) => r.kebele === selectedKebele);
          label = selectedKebele;
        } else if (selectedWoreda) {
          data = await fetchParameters("woreda");
          match = data.find((r) => r.woreda === selectedWoreda);
          label = selectedWoreda;
        } else if (selectedZone) {
          data = await fetchParameters("zone");
          match = data.find((r) => r.zone === selectedZone);
          label = selectedZone;
        } else if (selectedRegionalState) {
          data = await fetchParameters("regional-state");
          match = data.find((r) => r.regionalState === selectedRegionalState);
          label = selectedRegionalState;
        }
        if (!label) return;
        let nearestWaterBody = 0;
        if (
          match?.parameters?.water_bodies &&
          Array.isArray(match.parameters.water_bodies) &&
          match.parameters.water_bodies.length > 0
        ) {
          const nearestObj = match.parameters.water_bodies.reduce((min, w) =>
            w.distance_m < min.distance_m ? w : min
          );
          setWaterBodies(nearestObj);
          nearestWaterBody = nearestObj.distance_m;
        } else {
          setWaterBodies(null);
          nearestWaterBody = 0;
        }

        if (match) {
          setInputs({
            elevation: match.parameters.elevation || 0,
            rainfall: match.parameters.rainfall || 0,
            temperature_C: match.parameters.weather.temperature_C || 0,
            population_count: match.parameters.population || 0,
            humidity: match.parameters.weather.humidity || 0,
            water_bodies_distance: nearestWaterBody,
          });
          setLoadingParameters(false);

          setInlineMsg({
            text: `Parameters loaded for ${label}.`,
            type: "success",
          });
        } else {
          setInlineMsg({
            text: `No preset parameters found for ${label}.`,
            type: "warn",
          });
        }
      } catch (err) {
        console.error(err);
        setInlineMsg({
          text: "Failed to load parameters.",
          type: "error",
        });
      }
    }
    loadParameters();
  }, [selectedRegionalState, selectedZone, selectedWoreda, selectedKebele]);

  // Single prediction
  async function predictSingle() {
    try {
      setPredicting(true);
      const risk = await predictSingleAPI(inputs);
      const riskMapping = risk.predicted_risk;
      if (riskMapping == "0-10%") {
        setPredictionClass("Low");
        // console.log("low")
      } else if (
        riskMapping == "10-20%" ||
        riskMapping == "20-30%" ||
        riskMapping == "30-40%" ||
        riskMapping == "40-50%"
      ) {
        // console.log("medium")
        setPredictionClass("Medium");
      } else {
        // console.log("high")
        setPredictionClass("High");
      }

      setSinglePrediction(risk);
    } catch (err) {
      toast.error("Failed to get prediction!");
    } finally {
      setPredicting(false);
    }
  }

  async function handleBatchFile(e) {
    
    const f = e.target.files[0];
    if (!f) return;
    setBatchFileName(f.name);
    setBatchTable(null);
    setBatchErrors(null);
    if (!f.name.toLowerCase().endsWith(".csv")) {
      setBatchErrors("Only CSV files are allowed.");
      return;
    }
    setLoadingBatch(true);
    try {
      const text = await f.text();
      if (!text.trim()) {
        setBatchErrors("CSV file is empty.");
        return;
      }
      const lines = text
        .split("\n")
        .map((l) => l.trim())
        .filter((l) => l.length > 0);

      const firstLine = lines[0];
      const uploadedColumns = firstLine.split(",").map((c) => c.trim());
      const requiredColumns = [
        "elevation",
        "temperature_C",
        "humidity",
        "rainfall",
        "population_count",
        "water_bodies_distance",
      ];
      const missing = requiredColumns.filter(
        (req) => !uploadedColumns.includes(req)
      );

      if (missing.length > 0) {
        setBatchErrors(`Missing required columns: ${missing.join(", ")}`);
        return;
      }
      const MIN_ROWS = 1;
      const MAX_ROWS = 500000;
      const rowCount = lines.length - 1;
      if (rowCount < MIN_ROWS) {
        setBatchErrors(`CSV must contain at least ${MIN_ROWS} data row(s).`);
        return;
      }
      if (rowCount > MAX_ROWS) {
        setBatchErrors(`CSV cannot contain more than ${MAX_ROWS} rows.`);
        return;
      }
      const data = await predictBatchAPI(f);
      if (data.error) {
        setBatchErrors(data.error);
        return;
      }
      const header = Object.keys(data[0]);
      setBatchTable({ header, rows: data });
    } catch (err) {
      console.error(err);
      setBatchErrors("Failed to process CSV.");
    } finally {
      setLoadingBatch(false);
    }
  }

  // Download CSV
  function downloadBatchCSV() {
    if (!batchTable) return;
    const csv = [
      batchTable.header.join(","),
      ...batchTable.rows.map((r) =>
        batchTable.header.map((h) => r[h] || "").join(",")
      ),
    ].join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `batch_predictions_${batchFileName || "results"}`;
    a.click();
    URL.revokeObjectURL(url);
  }

  // Render batch table
  function renderTable() {
    if (!batchTable) return null;
    const riskSummary = batchTable.rows.reduce((acc, r) => {
      const riskClass = mapRiskRangeToClass(r.predicted_risk);
      acc[riskClass] = (acc[riskClass] || 0) + 1;
      return acc;
    }, {});

    // const riskSummary = batchTable.rows.reduce((acc, r) => {
    //   acc[r.predicted_risk] = (acc[r.predicted_risk] || 0) + 1;
    //   return acc;
    // }, {});

    //  Filter rows based on search
    const filteredRows = batchTable.rows.filter((row) =>
      batchTable.header.some((h) =>
        String(row[h] || "")
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
      )
    );

    //  Pagination logic
    const totalPages =
      rowsPerPage === "All" ? 1 : Math.ceil(filteredRows.length / rowsPerPage);
    const startIndex =
      rowsPerPage === "All" ? 0 : (currentPage - 1) * rowsPerPage;
    const paginatedRows =
      rowsPerPage === "All"
        ? filteredRows
        : filteredRows.slice(startIndex, startIndex + rowsPerPage);

    return (
      <div className="batch-table-card">
        {/* Summary + Actions */}
        <div
          className="batch-summary-row"
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "10px",
          }}
        >
          <div
            className="batch-summary"
            style={{ display: "flex", gap: "15px" }}
          >
            <strong>Risk Summary :</strong>
            {/* {["Low", "Moderate", "High"].map((risk) => (
              <span
                key={risk}
                style={{ color: riskColors[risk], fontWeight: 600 }}
              >
                {risk} : {riskSummary[risk] || 0}
              </span>
            ))} */}
            {["Low", "Moderate", "High"].map((risk) => (
              <span
                key={risk}
                style={{
                  color: riskColors[risk],
                  fontWeight: 600,
                }}
              >
                {risk}: {riskSummary[risk] || 0}
              </span>
            ))}
          </div>

          <div
            className="table-actions"
            style={{ display: "flex", gap: "10px", alignItems: "center" }}
          >
            {/* Search */}
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
              className="small"
            />

            {/* Rows per page selector */}
            <select
              value={rowsPerPage}
              onChange={(e) => {
                setRowsPerPage(
                  e.target.value === "All" ? "All" : Number(e.target.value)
                );
                setCurrentPage(1);
              }}
              className="small"
            >
              <option value={10}>10 records</option>
              <option value={20}>20 records</option>
              <option value={50}>50 records</option>
              <option value="All">All</option>
            </select>

            <button className="small" onClick={downloadBatchCSV}>
              Download CSV
            </button>
          </div>
        </div>

        {/* Table */}
        <div className="table-wrapper" style={{ overflowX: "auto" }}>
          <table className="dark-table sticky-header">
            <thead>
              <tr>
                <th>#</th>
                {batchTable.header.map((h) => (
                  <th key={h}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {paginatedRows.map((r, i) => (
                <tr key={i}>
                  <td style={{ fontWeight: 600, textAlign: "center" }}>
                    {startIndex + i + 1}
                  </td>
                  {batchTable.header.map((h) => {
                    const val = r[h];
                    // if (h === "predicted_risk") {
                    //   return (
                    //     <td
                    //       key={h}
                    //       style={{
                    //         color: riskColors[val] || "#fff",
                    //         fontWeight: 700,
                    //         backgroundColor: `${riskColors[val]}22`,
                    //         textAlign: "center",
                    //         borderRadius: "4px",
                    //       }}
                    //     >
                    //       {val}
                    //     </td>
                    //   );
                    // }
                    if (h === "predicted_risk") {
                      const riskClass = mapRiskRangeToClass(val);
                      return (
                        <td
                          key={h}
                          style={{
                            color: riskColors[riskClass],
                            fontWeight: 700,
                            backgroundColor: `${riskColors[riskClass]}22`,
                            textAlign: "center",
                            borderRadius: "4px",
                          }}
                        >
                          {val} ({riskClass})
                        </td>
                      );
                    }

                    return <td key={h}>{val}</td>;
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        {rowsPerPage !== "All" && totalPages > 1 && (
          <div
            className="pagination"
            style={{
              marginTop: "12px",
              display: "flex",
              justifyContent: "center",
              gap: "6px",
              flexWrap: "wrap",
            }}
          >
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            >
              Prev
            </button>

            {(() => {
              const pages = [];
              const maxVisible = 7;
              let start = Math.max(1, currentPage - 3);
              let end = Math.min(totalPages, currentPage + 3);
              if (currentPage <= 4) {
                end = Math.min(totalPages, maxVisible);
              } else if (currentPage > totalPages - 4) {
                start = Math.max(1, totalPages - maxVisible + 1);
              }
              if (start > 1) {
                pages.push(
                  <button key={1} onClick={() => setCurrentPage(1)}>
                    1
                  </button>
                );
                if (start > 2)
                  pages.push(<span key="start-ellipsis">...</span>);
              }
              for (let i = start; i <= end; i++) {
                pages.push(
                  <button
                    key={i}
                    className={currentPage === i ? "active" : ""}
                    onClick={() => setCurrentPage(i)}
                  >
                    {i}
                  </button>
                );
              }
              if (end < totalPages) {
                if (end < totalPages - 1) {
                  pages.push(<span key="end-ellipsis">...</span>);
                }
                pages.push(
                  <button
                    key={totalPages}
                    onClick={() => setCurrentPage(totalPages)}
                  >
                    {totalPages}
                  </button>
                );
              }

              return pages;
            })()}

            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => p + 1)}
            >
              Next
            </button>
          </div>
        )}
      </div>
    );
  }
  function openFullscreen(images) {
    const elem =
      typeof images[0] === "string"
        ? document.querySelector(`img[src="${images[0]}"]`)
        : images[0];

    if (!elem) return;

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Safari */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE11 */
      elem.msRequestFullscreen();
    }
  }

  return (
    <div className="risk-app">
      <ToastContainer />
      {/* Snackbar commented out as per request */}
      {false && (
        <div className="snackbar">
          {/* snackbar.message */}
          <button>✖</button>
        </div>
      )}
      <div className="container-wide">
        <p className="title">Schistosomiasis Risk Predictor</p>
        <p className="caption">
          Estimate the risk level of schistosomiasis using environmental and
          demographic data.
        </p>

        <div className="tabs-row">
          <button
            className={tab === "single" ? "tab active" : "tab"}
            onClick={() => setTab("single")}
          >
            Single Input Prediction
          </button>
          <button
            className={tab === "batch" ? "tab active" : "tab"}
            onClick={() => setTab("batch")}
          >
            Batch Prediction from CSV
          </button>
          {/* <button
            className={tab === "trends" ? "tab active" : "tab"}
            onClick={() => setTab("trends")}
          >
            Trends
          </button> */}
        </div>

        <hr className="divider" />

        {/* SINGLE INPUT */}
        {loadingParameters ? (
          <div style={spinnerOverlayStyle}>
            <div style={spinnerStyle}></div>
          </div>
        ) : (
          tab === "single" && (
            <section>
              <div
                className="section-title-row"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  flexWrap: "wrap",
                  marginBottom: 8,
                }}
              >
                <p className="section-title" style={{ margin: 0 }}>
                  Enter Parameters Manually
                </p>
                {inlineMsg.text && (
                  <small
                    style={{
                      color:
                        inlineMsg.type === "success"
                          ? "#16a34a"
                          : inlineMsg.type === "warn"
                          ? "#f59e0b"
                          : inlineMsg.type === "error"
                          ? "#ef4444"
                          : "#024795",
                      opacity: 0.95,
                      fontWeight: 500,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {inlineMsg.text}
                  </small>
                )}
              </div>
              <div className="level-selector">
                <div className="form-group row">
                  <label className="form-label">Select Regional State:</label>
                  <select
                    className="woreda-select"
                    value={selectedRegionalState}
                    onChange={(e) => {
                      setSelectedRegionalState(e.target.value);
                      setSelectedZone("");
                      setSelectedWoreda("");
                      setSelectedKebele("");
                      setSinglePrediction(null);
                    }}
                  >
                    <option value="">Select Regional State</option>
                    {regionalStates.map((r, i) => (
                      <option key={i} value={r}>
                        {r}
                      </option>
                    ))}
                  </select>
                </div>
                {/* --- ZONE (only show after state selected) --- */}
                {selectedRegionalState && zones.length > 0 && (
                  <div className="form-group row">
                    <label className="form-label">Select Zone:</label>
                    <select
                      className="woreda-select"
                      value={selectedZone}
                      onChange={(e) => {
                        setSelectedZone(e.target.value);
                        setSelectedWoreda("");
                        setSelectedKebele("");
                        setSinglePrediction(null);
                      }}
                    >
                      <option value="">Select Zone</option>
                      {zones.map((z, i) => (
                        <option key={i} value={z}>
                          {z}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {/* --- WOREDA (only show after zone selected) --- */}
                {selectedZone && woredas.length > 0 && (
                  <div className="form-group row">
                    <label className="form-label">Select Woreda:</label>
                    <select
                      className="woreda-select"
                      value={selectedWoreda}
                      onChange={(e) => {
                        setSelectedWoreda(e.target.value);
                        setSelectedKebele("");
                      }}
                    >
                      <option value="">Select Woreda</option>
                      {woredas.map((w, i) => (
                        <option key={i} value={w}>
                          {w}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {/* --- KEBELE (only show after woreda selected) --- */}
                {selectedWoreda && kebeles.length > 0 && (
                  <div className="form-group row">
                    <label className="form-label">Select Kebele:</label>
                    <select
                      className="woreda-select"
                      value={selectedKebele}
                      onChange={(e) => setSelectedKebele(e.target.value)}
                    >
                      <option value="">Select Kebele</option>
                      {kebeles.map((k, i) => (
                        <option key={i} value={k}>
                          {k}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </div>

              {selectedRegionalState && (
                <div className="card">
                  {/* First Row of Range Fields */}
                  <div className="range-fields-row">
                    <RangeField
                      label="Elevation (m)"
                      min={0}
                      max={5000}
                      step={1}
                      value={inputs?.elevation ?? 0}
                      onChange={(v) =>
                        setInputs((prev) => ({ ...prev, elevation: v }))
                      }
                    />
                    <RangeField
                      label="Rainfall (mm)"
                      min={0}
                      max={2000}
                      step={1}
                      value={inputs?.rainfall ?? 0}
                      onChange={(v) => setInputs({ ...inputs, rainfall: v })}
                    />
                    {/* <RangeField
                    label="NDVI"
                    min={0}
                    max={1}
                    step={0.01}
                    value={inputs.ndvi}
                    onChange={(v) => setInputs({ ...inputs, ndvi: v })}
                  /> */}
                  </div>

                  {/* Second Row of Range Fields */}
                  <div className="range-fields-row">
                    <RangeField
                      label="Temperature (°C)"
                      min={0}
                      max={40}
                      step={0.1}
                      value={inputs?.temperature_C ?? 0}
                      onChange={(v) =>
                        setInputs({ ...inputs, temperature_C: v })
                      }
                    />
                    <RangeField
                      label="Population Count"
                      min={0}
                      max={1000}
                      step={1}
                      value={inputs?.population_count ?? 0}
                      onChange={(v) =>
                        setInputs({ ...inputs, population_count: v })
                      }
                    />
                    <RangeField
                      label="Humidity (%)"
                      min={0}
                      max={100}
                      step={1}
                      value={inputs?.humidity ?? 0}
                      onChange={(v) => setInputs({ ...inputs, humidity: v })}
                    />
                  </div>
                  {/* Water Bodies Section */}
                  {waterBodies ? (
                    <div className="water-body-section">
                      <div className="section-header">
                        <h3 className="section-title">Nearest Water Body</h3>
                      </div>

                      <div className="water-bodies-grid">
                        <div className="water-body-card">
                          <div className="water-body-header">
                            <div className="water-body-icon">1</div>
                            <h4 className="water-body-title">
                              {waterBodies?.tags?.name ??
                                waterBodies.name ??
                                "Unnamed Water Body"}
                            </h4>
                          </div>

                          <div className="water-body-details">
                            <div className="detail-row">
                              <span className="detail-label">Type</span>
                              <span className="detail-value">
                                {capitalizeWords(
                                  waterBodies?.tags?.water ??
                                    waterBodies.water_type
                                )}
                              </span>
                            </div>

                            <div className="detail-row">
                              <span className="detail-label">Distance</span>
                              <span className="detail-value">
                                {Number(waterBodies?.distance_m).toFixed(2)}{" "}
                                meters
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="water-body-section">
                      <div className="section-header">
                        <h3 className="section-title">
                          No water body data available.
                        </h3>
                      </div>
                    </div>
                  )}

                  <div className="action-row" style={{ gridColumn: "1 / -1" }}>
                    <button
                      className="primary"
                      onClick={predictSingle}
                      disabled={predicting}
                    >
                      {predicting ? "Predicting..." : "Predict Risk"}
                    </button>

                    {singlePrediction && !predicting && (
                      <div
                        className="prediction-pill"
                        style={{
                          borderColor:
                            riskColors[singlePrediction.predicted_risk],
                        }}
                      >
                        <strong
                          style={{
                            color: riskColors[singlePrediction.predicted_risk],
                          }}
                        >
                          {singlePrediction.predicted_risk} ({predictionClass})
                          {/* Predicted Risk: {singlePrediction.predicted_risk} */}
                        </strong>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </section>
          )
        )}
        {/* BATCH INPUT */}
        {tab === "batch" && (
          <>
            <section>
              <p className="section-title">
                Upload CSV File for Batch Prediction
              </p>
              <p className="muted">
                Your CSV file <strong>must</strong> contain:{" "}
                {REQUIRED_COLS.map((c, i) => (
                  <code
                    key={c}
                    style={{
                      marginRight: 6,
                      color: "#007A00",
                      textDecoration: "underline",
                      textDecorationColor: "#007A00",
                    }}
                  >
                    {c}
                    {i < REQUIRED_COLS.length - 1 ? "," : ""}
                  </code>
                ))}
              </p>
              <div className="card upload-card">
                <label className="uploader">
                  <div className="upload-icon">
                    <IoMdCloudUpload
                      style={{ height: "50px", width: "50px" }}
                    />
                  </div>
                  <div>
                    <div className="uploader-title">
                      Drag and drop file here
                    </div>
                  </div>
                  <input type="file" accept=".csv" onChange={handleBatchFile} />
                  <div className="uploader-btn">Browse files</div>
                </label>
                {batchFileName && (
                  <div className="uploaded-name">{batchFileName}</div>
                )}
                {batchErrors && <div className="error">{batchErrors}</div>}
              </div>
              <div style={{ marginTop: 20 }}>
                {loadingBatch ? <div className="loader"></div> : renderTable()}
              </div>
            </section>
            <div>
              <p>
                Here is the example parameters CSV :{" "}
                <button className="primary" onClick={downloadSampleCSV}>
                  {" "}
                  Download{" "}
                </button>
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

// RangeField Component
function RangeField({ label, min, max, step, value, onChange }) {
  const pct =
    ((Number(value) - Number(min)) / (Number(max) - Number(min))) * 100;
  const percent = Math.max(0, Math.min(100, pct));
  const showValue =
    Math.abs(step) < 1 && String(step).includes(".")
      ? Number(value).toFixed(2)
      : Number(value).toFixed(0);

  // Blue gradient for track
  const trackStyle = {
    background: `linear-gradient(90deg, #024795 ${percent}%, rgba(59,130,246,0.1) ${percent}%)`,
  };

  // Bubble color matches dark blue text
  const bubbleStyle = {
    left: `${percent}%`,
    transform: `translateX(${
      percent < 5 ? "0" : percent > 95 ? "-100%" : "-50%"
    })`,
    color: "#024795",
  };

  return (
    <div className="range-field">
      <label className="range-label">{label}</label>
      <div
        className="range-wrapper"
        style={{ position: "relative", paddingTop: 18 }}
      >
        <div className="range-value-bubble" style={bubbleStyle}>
          {showValue}
        </div>
        <input
          type="range"
          aria-label="Adjust red intensity"
          min={min}
          max={max}
          step={step}
          value={value}
          className="input-range"
          onChange={(e) => onChange(Number(e.target.value))}
          style={trackStyle}
        />
      </div>
    </div>
  );
}
